// // import { disconnectSocket, initializeSocket } from "@endpoints/socket";
// // import { RootState } from "@store/reducers";
// // import React, { createContext, useContext, useEffect, useRef } from "react";
// // import { useSelector } from "react-redux";
// // // import {useAppSelector} from '@redux/hooks';
// // // import {initializeSocket, disconnectSocket} from '@services/socket';

// // const SocketContext = createContext<any>(null);

// // export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
// //   children,
// // }) => {
// //   const socketRef = useRef<any>(null);
// //   const { token } = useSelector((state: RootState) => state.auth);

// //   useEffect(() => {
// //     const setup = async () => {
// //       if (token) {
// //         socketRef.current = await initializeSocket(token);
// //       } else {
// //         disconnectSocket();
// //         socketRef.current = null;
// //       }
// //     };
// //     setup();

// //     return () => disconnectSocket();
// //   }, [token]);

// //   return (
// //     <SocketContext.Provider value={socketRef}>
// //       {children}
// //     </SocketContext.Provider>
// //   );
// // };

// // export const useSocket = () => useContext(SocketContext);

// import { disconnectSocket, initializeSocket, getSocket } from "@endpoints/socket";
// import { RootState } from "@store/reducers";
// import React, { createContext, useContext, useEffect, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { updateAccessToken } from "@store/actions/auth.action";
// import { refreshTokenService } from "@endpoints/auth.service";

// const SocketContext = createContext<any>(null);

// export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
//   children,
// }) => {
//   const socketRef = useRef<any>(null);
//   const dispatch = useDispatch();
//   const { token, refreshToken } = useSelector((state: RootState) => state.auth);

//   // ✅ 1. Initialize socket when token changes
//   useEffect(() => {
//     const setup = async () => {
//       if (token) {
//         socketRef.current = await initializeSocket(token);
//       } else {
//         disconnectSocket();
//         socketRef.current = null;
//       }
//     };
//     setup();

//     return () => disconnectSocket();
//   }, [token]);

//   // ✅ 2. Auto-refresh token every 4 minutes
//   useEffect(() => {
//     if (!refreshToken) return;

//     const interval = setInterval(async () => {
//       try {
//         const res: any = await refreshTokenService(refreshToken);

//         if (res?.token) {
//           // update Redux store
//           dispatch(updateAccessToken(res.token));

//           // 🔥 update the existing socket auth token
//           const socket = getSocket();
//           if (socket) {
//             socket.auth = { token: res.token };
//             socket.connect(); // reconnect with new token (no disconnect)
//           }
//         }
//       } catch (err) {
//         console.log("Token auto-refresh failed:", err);
//       }
//     }, 4 * 60 * 1000); // 4 minutes

//     return () => clearInterval(interval);
//   }, [refreshToken]);

//   return (
//     <SocketContext.Provider value={socketRef}>
//       {children}
//     </SocketContext.Provider>
//   );
// };

// export const useSocket = () => useContext(SocketContext);

// In SocketProvider.tsx - replace with this version
// In SocketProvider.tsx - REPLACE with this version
import { initializeSocket, disconnectSocket } from "@endpoints/socket";
import {
  fetchJobMessagesProfile,
  fetchUnseenMessageCount,
} from "@store/actions/message.action";
import store from "@store/index";
import { playNotificationSound } from "@utils/helperFunction";
import { useSnackbar } from "notistack";
import React, { createContext, useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

const SocketContext = createContext<any>(null);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const socketRef = useRef<any>(null);
  const { enqueueSnackbar } = useSnackbar();
  const { logged_in, user } = useSelector((state: any) => state.auth);

  useEffect(() => {
    console.log("🔄 SocketProvider: Auth state changed", {
      logged_in,
      userId: user?._id,
    });

    if (logged_in && user) {
      const sessionId = localStorage.getItem("sessionId");
      console.log(
        "🔗 SocketProvider: Initializing socket with sessionId:",
        sessionId
      );

      if (!sessionId) {
        console.error("❌ SocketProvider: No sessionId found");
        return;
      }

      // Initialize socket
      const socket = initializeSocket();
      socketRef.current = socket;

      // Add detailed event listeners
      socket?.on("connect", () => {
        console.log(
          "✅ SocketProvider: Socket connected successfully",
          socket.id
        );
      });

      socket?.on("disconnect", (reason) => {
        console.log("🔌 SocketProvider: Socket disconnected", reason);
      });

      socket?.on("connect_error", (err) => {
        console.error("❌ SocketProvider: Connection error", err.message);
      });

      socket?.on("newMessage", (message) => {
        const currentRoute = window.location.pathname;
        if (!currentRoute?.includes("messages")) {
          console.log("onMessage", message);
          playNotificationSound();
          enqueueSnackbar(`Message : ${message?.message}`, {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
        store.dispatch(fetchJobMessagesProfile());
        store.dispatch(fetchUnseenMessageCount());
        console.log("currentRoute", currentRoute);
      });

      // Debug all incoming events
      socket?.onAny((event, ...args) => {
        if (event !== "pong") {
          // Filter out pong to reduce noise
          console.log(`📨 SocketProvider: Received event [${event}]`, args);
        }
      });

      return () => {
        console.log("🧹 SocketProvider: Cleaning up socket listeners");
        if (socketRef.current) {
          socketRef.current.removeAllListeners();
        }
      };
    } else {
      console.log(
        "🚫 SocketProvider: User not logged in, disconnecting socket"
      );
      disconnectSocket();
      socketRef.current = null;
    }
  }, [logged_in, user?._id]); // Re-run when user ID changes

  return (
    <SocketContext.Provider value={socketRef}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
